// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documentation-tab {
  margin-top: 30px;
  font-size: var(--g-text-body-1-font-size);
  overflow: auto;
  max-height: 365px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogErrorWithTabs/Tabs/DocumentationTab/DocumentationTab.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,yCAAA;EACA,cAAA;EACA,iBAAA;AACJ","sourcesContent":[".documentation-tab {\n  margin-top: 30px;\n  font-size: var(--g-text-body-1-font-size);\n  overflow: auto;\n  max-height: 365px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
